import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
  name: 'moment'
})
export class MomentPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}

@Pipe({
  name: 'momentAgo',
})

export class MomentPipeAgo implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(date: any, format: any) {
    // let ln = this.translate.currentLang || 'en';
    let ln = localStorage.getItem("language");
    let year = ln === 'th' ? 543 : 0;
    moment.locale(ln);

    let d: any;
    if (date) {
      d = moment(date).add('year', year).format(format);
    } else {
      d = "-"
    }
    return d
  }
}

@Pipe({
  name: 'momentFull',
})

export class MomentFullPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(date: any, format: any) {
    let d: any;
    let ln = this.translate.currentLang || 'en';
    let year = ln === 'th' ? 543 : 0;
    moment.locale(ln);
    if (date) {
      d = moment(date).format(format);
    } else {
      d = "-"
    }

    let y = format.indexOf("YYYY");
    if (y !== -1) {
      let ln = this.translate.currentLang || 'en';
      let year = ln === 'th' ? 543 : 0;
      let d2 = moment(date).add('year', year).format(format);

      let str = d.substr(d.length - 4, 4);
      let _str = d2.substr(d2.length - 4, 4);
      d = d.replace(str, _str);
    }

    return d
  }
}

@Pipe({
  name: 'momentTh',
})

export class MomentThPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(date: any, format: any) {
    let ln = this.translate.currentLang || 'en';
    let year = ln === 'th' ? 543 : 0;
    moment.locale(ln);

    let d: any;
    if (date != null) {
      d = moment(date).add('year', year).format(format);
    } else {
      d = "-"
    }
    return d
  }
}

@Pipe({
  name: 'momentThstartOf',
})

export class MomentThPipestartOf implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(date: any) {
    const ln = this.translate.currentLang || 'en';
    moment.locale(ln);

    let d: any;
    if (date != null) {
      d = moment(date).startOf('minute').fromNow();
    } else {
      d = '-'
    }
    return d;
  }
}

@Pipe({
  name: 'momentThMonth',
})

export class MomentThMonth implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(date: any) {

    let ln = this.translate.currentLang || 'en';
    moment.locale(ln);

    let d: any;
    if (date != null) {
      d = moment(date).format('MMM')
    } else {
      d = "-"
    }
    return d
  }
}

@Pipe({
  name: 'momentThYear',
})

export class MomentThYear implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(date: any) {

    let ln = this.translate.currentLang || 'en';
    let year = ln === 'th' ? 543 : 0;
    moment.locale(ln);

    let d: any;
    if (date != null) {
      d = moment(date).add('year', year).format('YYYY');
    } else {
      d = "-"
    }
    return d
  }
}

@Pipe({
  name: 'momentNoAddYear',
})

export class MomentNoAddYearPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(date: any, format: any) {

  

    return date ? moment(date).format(format) : '';
  }
}

@Pipe({
  name: 'momentTime',
})

export class MomentTimePipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(date: any) {

    let ln = this.translate.currentLang || 'en';

    moment.locale(ln);

    return date ? moment(date).format('LT') : '';
  }
}